import {ApiUtils} from "@/utils/ApiUtils";
import {getStatusColor} from "@/utils/ScheduleEvent";

export default {
    methods: {
        updateEventFromSocketUpdateSingle({event}){
            const vm = this
            if(vm.currentEvent){
                const currentEvent = JSON.parse(JSON.stringify(vm.currentEvent))
                vm.setEvent({...currentEvent, ...event})
            }
        },
        updateEventFromSocketUpdate(evt){
            const vm = this
            const newEvent = JSON.parse(JSON.stringify(evt.event))
            console.debug('Event updated: ', newEvent)
            const foundIndex = vm.appointments.findIndex(event => event.id === newEvent.id)

            if(foundIndex === -1) return
            vm.appointments.splice(foundIndex, 1, newEvent)

            const message = `Cita de las ${vm.$moment(newEvent.time, 'HH:mm:ss').format('HH:mm')} actualizada`
            const messageColor = getStatusColor(newEvent.event_status_id)
            vm.showSnackBar({
                text: message,
                color: messageColor
            })
            vm.highlight(newEvent.id)

        },
        updateClientListEvent(event, message, onToastClick = () => {}){
            var vm = this
            vm.snackBarClick = onToastClick

            const eventIndex = vm.events.findIndex(evt => {
                return evt.id === event.id
            })

            if(eventIndex !== -1){
                vm.notify(message, 'green')
                vm.events.splice(eventIndex, 1,  vm.formatEvent(event))
            }else{
                if(event.date === vm.date){
                    vm.notify(message, 'green')
                    vm.events.push(vm.formatEvent(event))
                }
            }

        },
        async cancelAppointment(appointmentId, cancelReason){

            const response = await ApiUtils.makePost(`appointments/${appointmentId}/cancel`, {
                reason: cancelReason
            })

            if(!response.ok){
                return false
            }

            const json = await response.json()
            return json

        }
    }
}
